import { ShowCallInfoResultSaveStatus } from '@/models/Visitour/ShowCallInfoResult';

export default (value: any, scheduledDate: Date, SaveStatus: number) => {
    const convertedScheduledDate = new Date(scheduledDate).toDateString();
    const defaultDate = new Date('0001-01-01T00:00:00Z').toDateString();

    if (convertedScheduledDate === defaultDate){
      return 'Please contact our team on 0345 072 4387';
    }
    switch (value) {
      case 1: return 'Scheduled - please confirm';
      case 2: return 'Confirmed';
      case 3: return SaveStatus === ShowCallInfoResultSaveStatus.Confirmed ? 'Confirmed' : 'Scheduled - please confirm';
      default: return 'Please contact our team on 0345 072 4387';
    }
  };